module.exports = __webpack_public_path__ + "img/homeIcon4.8ab3657c.svg";